import SectionHeader from "../eventsExperiences/SectionHeader";
// Placeholder photos until the final campaign images are ready.
import briefImg from "../../assets/images/whatwedo/influencerMarketing/howItWorks/brief.jpg";
import planImg from "../../assets/images/whatwedo/eventsExperiences/eventsServices/01.jpg";
import launchImg from "../../assets/images/whatwedo/influencer-marketing.jpg";
import reportImg from "../../assets/images/whatwedo/contentCreation.jpg";

const STEPS = [
  { tone: "dark", image: briefImg, title: "Brief", desc: "Tell us your goal, audience and budget.", tags: "Goal · Audience · Budget" },
  { tone: "light", image: planImg, title: "Plan", desc: "We propose creators, content ideas and a timeline.", tags: "Creators · Content ideas · Timeline" },
  { tone: "dark", image: launchImg, title: "Launch", desc: "Creators shoot, you approve, content goes live.", tags: "Shoot · Approve · Go live" },
  { tone: "red", image: reportImg, title: "Report", desc: "You get results per creator and what to do next.", tags: "Results per creator · Next steps" },
];

// Cards stick one step lower and further right than the last as you scroll,
// so they stack into a staircase (--i drives the offsets).
const InfluencerProcess = () => (
  <section className="ee-section im-process">
    <div className="container">
      <SectionHeader eyebrow="Our process" title="How it" accent="works." />
      <div className="im-steps">
        {STEPS.map(({ tone, image, title, desc, tags }, i) => (
          <article className={`im-step im-step--${tone}`} key={title} style={{ "--i": i }}>
            <div className="im-step-copy">
              <h3><span>0{i + 1}</span> {title}</h3>
              <p>{desc}</p>
              <small>{tags}</small>
            </div>
            <img className="im-step-img" src={image} alt="" loading="lazy" />
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default InfluencerProcess;
